module.exports = __webpack_public_path__ + "img/pan-pereklad.1b2af096.png";